module.exports = __webpack_public_path__ + "static/media/ymy.6d7c4c0f.png";